module.exports = __webpack_public_path__ + "static/work-krave-c440b255edc80b7931285df32b4971be.jpg";